<router-outlet />

@for (position of toastPositions; track position) {
  @if (toastService.toastsByPosition(position); as positionToasts) {
    @if (positionToasts.length) {
      <div class="toast-stack" [ngClass]="position">
        @for (t of positionToasts; track t.id) {
          <app-toast
            [stacked]="true"
            [variant]="t.variant"
            [title]="t.title"
            [description]="t.description"
            [position]="t.position"
            [actionLabel]="t.actionLabel"
            (actionClick)="t.onAction?.()"
            (closeClick)="toastService.hide(t.id)"
          ></app-toast>
        }
      </div>
    }
  }
}